import React, { useState, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { prices } from "./Prices";
import { useBooking } from "./BookingContext";

const Step1 = () => {
  const { bookingData, updateBookingData } = useBooking(); // Added bookingData to destructuring
  const [showModal, setShowModal] = useState(false);
  const nextBtnRef = useRef(null); // Ref for Next button

  const handlePlanChange = (e) => {
    const planValue = e.target.value;
    updateBookingData("plan", planValue);

    // Also update package to match for Dedicated logic compatibility, or ensure we check 'plan'
    // The previous code used 'package' for dedicated. Let's ensure consistency.
    if (planValue === 'dedicated') {
      updateBookingData("package", "dedicated");
    } else {
      updateBookingData("package", planValue); // or null?
    }

    // Also save to localStorage for jQuery access
    localStorage.setItem("selectedPlan", planValue);
  };

  useEffect(() => {
    // Show modal on initial page load
    setShowModal(true);
  }, []);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  // Dedicated Workspace State and Handlers
  const [isDedicatedModalOpen, setIsDedicatedModalOpen] = useState(false);
  const [dedicatedContact, setDedicatedContact] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const contactEmail = "workspace@abiatechhub.com";

  const handleDedicatedContactChange = (e) => {
    const { name, value } = e.target;
    setDedicatedContact((prev) => ({ ...prev, [name]: value }));
  };

  const closeDedicatedModal = () => {
    setIsDedicatedModalOpen(false);
  };

  const handleDedicatedCardClick = (e) => {
    e.preventDefault();
    // Just select the plan, do NOT open modal immediately
    updateBookingData("plan", "dedicated");
    updateBookingData("package", "dedicated");
  };

  const handleSubmitInquiry = async (e) => {
    e.preventDefault();
    if (!dedicatedContact.name || !dedicatedContact.email || !dedicatedContact.message) {
      alert("Please fill in all fields.");
      return;
    }

    if (!recaptchaToken) {
      alert("Please complete the ReCaptcha verification.");
      return;
    }

    setIsSubmitting(true);
    try {
      // Determine the base API URL
      const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
      const apiUrl = isLocalhost ? "http://localhost:8000/api/inquiry" : "/api/inquiry";

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({ ...dedicatedContact, recaptchaToken }),
      });

      let data;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        data = await response.json();
      } else {
        const text = await response.text();
        console.error("Non-JSON response received:", text);
        throw new Error(`Server returned ${response.status}: ${text.substring(0, 100)}`);
      }

      if (!data.error) {
        alert("Your inquiry has been sent successfully!");
        setDedicatedContact({ name: "", email: "", message: "" });
        setRecaptchaToken(null); // Reset captcha
        closeDedicatedModal();
      } else {
        alert(data.message || "Failed to send inquiry. Please try again.");
      }
    } catch (error) {
      console.error("Error sending inquiry:", error);
      alert(`An error occurred: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const nextBtn = nextBtnRef.current;
    if (!nextBtn) return;

    const handleNextClick = (e) => {
      // Check if current plan is dedicated
      // accessing state directly here might be stale if strict mode/closures, but bookingData is from context
      // simpler to rely on the latest context value if it updates.
      // However, event listener might capture stale 'bookingData' if not careful with dependency array.

      // Actually, we can check the selected radio button too or trust the context which is in dependency array

      // Let's use the DOM check for robustness if context is tricky in listeners
      const dedicatedInput = document.querySelector('input[name="plan"][value="dedicated"]');

      if (bookingData.plan === 'dedicated' || (dedicatedInput && dedicatedInput.checked)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Open Modal
        setIsDedicatedModalOpen(true);
        return false;
      }
      // Otherwise let it proceed
    };

    // We need to use capture phase or add it such that it runs BEFORE the wizard's logic
    // The wizard likely uses jQuery or normal click listeners. 
    // React's onClick on elements is synthetic and bubbles. 
    // Adding a native listener to the ref element is safer for interception.

    nextBtn.addEventListener('click', handleNextClick, true); // Use capture to ensure we get it first? Or just normal phase.

    return () => {
      nextBtn.removeEventListener('click', handleNextClick, true);
    };

  }, [bookingData.plan]); // Re-bind if plan changes

  useEffect(() => {
    if (!isDedicatedModalOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsDedicatedModalOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isDedicatedModalOpen]);

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open");
      document.body.style.paddingRight = "0px"; // Reset padding
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [showModal]);

  //   useEffect(() => {
  //     $(document).ready(function(){
  //       $("#exampleModal").modal('show');
  //   });
  // })

  // function closeModal() {
  //   $("#exampleModal").modal('hide');
  // }

  return (
    <>

      <div
        className="multisteps-form__panel js-active"
        data-animation="slideHorz"
      >
        <div className="wizard-forms">
          <div className="inner pb-100 clearfix">
            <div className="form-content pera-content">
              <div className="step-inner-content">
                <span className="step-no">Step 1</span>
                <h2>
                  Unleash Your Potential Today: For As Low As{" "}
                  <span className="text-success "> ₦4000</span> Your Perfect
                  Workspace is Just a Few Clicks Away.
                </h2>
                <p>
                  Our office space offers everything you need to excel in your
                  work, from high-speed internet to comfortable seating. Choose
                  a plan and unlock your potential today.
                </p>
                <div className="btn-space">
                  <button
                    type="button"
                    className="btn btn-primary ath mt-3 btn-lg "
                    data-toggle="modal"
                    data-target="#exampleModal"
                    onClick={openModal}
                  // onClick={() => modalRef.current && modalRef.current.show()}
                  >
                    View price list
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary ath mt-3 btn-lg"
                  >
                    <a
                      href="https://maps.app.goo.gl/iq7MziQJX7QV2i4q9"
                      target="_blank"
                    >
                      Get Direction
                    </a>
                  </button>
                </div>
                <div className="step-box">
                  <h1 style={{ textAlign: "center" }}>Choose A Plan</h1>
                  <div className="row cards pt-5">
                    <div className="col-md-4 h-card ">
                      <label className="relative-position text-center step-box-content bg-white  active  c-card">
                        <span className="step-box-icon">
                          <img src="/assets/img/d1.png" alt="" />
                        </span>
                        <span className="step-box-text">Daily Plan</span>
                        <span className="service-check-option">
                          <span>
                            <input
                              type="radio"
                              name="plan"
                              className="plantime"
                              value="daily"
                              defaultChecked
                              onChange={handlePlanChange}
                            />
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="col-md-4 h-card">
                      <label className="step-box-content bg-white text-center relative-position c-card">
                        <span className="step-box-icon">
                          <img src="/assets/img/d2.png" alt="" />
                        </span>
                        <span className="step-box-text">Weekly Plan</span>
                        <span className="service-check-option">
                          <span>
                            <input
                              type="radio"
                              name="plan"
                              className="plantime"
                              value="weekly"
                              onChange={handlePlanChange}
                            />
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="col-md-4 h-card ">
                      <label className="step-box-content bg-white text-center relative-position c-card">
                        <span className="step-box-icon">
                          <img src="/assets/img/d3.png" alt="" />
                        </span>
                        <span className="step-box-text">Monthly Plan</span>
                        <span className="service-check-option">
                          <span>
                            <input
                              type="radio"
                              className="plantime"
                              name="plan"
                              value="monthly"
                              onChange={handlePlanChange}
                            />
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                  {/* Dedicated Workspace Card */}
                  <div className="row cards pt-3 justify-content-center">
                    <div className="col-md-4 h-card">
                      <label
                        className="step-box-content bg-white text-center relative-position c-card"
                        onClick={handleDedicatedCardClick}
                        style={{ cursor: "pointer" }}
                      >
                        <span className="step-box-icon">
                          <i className="fas fa-building icon-color" style={{ fontSize: "40px", marginBottom: "10px", display: "block", color: "#8a038c" }}></i>
                        </span>
                        <span className="step-box-text">Dedicated Workspace</span>
                        <span className="service-check-option">
                          <span>
                            <input
                              type="radio"
                              name="plan" // Keep name as plan or change to package? kept as plan for visual consistency in collection, but typically this is a 'package'
                              className="plantime"
                              value="dedicated"
                              checked={false} // Managed by visual state mainly, but ideally should reflect bookingData.plan === 'dedicated'
                              // We are handling visual active state via the label class mostly in this template
                              readOnly
                            />
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="actions d-flex justify-content-center align-items-center">
            <ul className="d-flex justify-content-center align-items-center">
              <li className="disable" aria-disabled="true">
                <span className="js-btn-next" title="NEXT">
                  Backward <i className="fa fa-arrow-right"></i>
                </span>
              </li>
              <li>
                <span className="js-btn-next ath" title="NEXT" ref={nextBtnRef}>
                  NEXT <i className="fa fa-arrow-right"></i>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* modal */}
      {showModal && (
        <>
          <div
            className={`modal ${showModal ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header float-right">
                  <h5>CO-Working Space(WITH INTERNET)</h5>
                  <button type="button" className="close" onClick={closeModal}>
                    &times;
                  </button>
                  <div className="text-right"></div>
                </div>
                <div className="modal-body">
                  <div>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Time</th>
                          <th scope="col">Price </th>
                          {/* <th scope="col">Price(old)</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">1</th>
                          <td>Daily</td>
                          <td>{prices[0].basic}</td>
                          {/* <td>1,400</td> */}
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>Weekly</td>
                          <td>{prices[1].basic}</td>
                          {/* <td>6,500</td> */}
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>Monthly</td>
                          <td>{prices[2].basic}</td>
                          {/* <td>25,000</td> */}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header float-right">
              <h5>CO-Working Space(WITH DATA)</h5>
              <div className="text-right">
              </div>
            </div>
            <div className="modal-body">
              <div>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Time</th>
                      <th scope="col">Price</th>
                      {/* <th scope="col">Price(old)</th> *
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Daily</td>
                      <td>{prices[0].standard}</td>
                      {/* <td>2,000</td> *
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td>Weekly</td>
                      <td>{prices[1].standard}</td>
                      {/* <td>9,500</td> *
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Monthly</td>
                      <td>{prices[2].standard}</td>
                      {/* <td>37,000</td> *
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header float-right">
                  <h5>TRAININGS and MEETING ROOMS</h5>
                  <div className="text-right"></div>
                </div>
                <div className="modal-body">
                  <div>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Time</th>
                          <th scope="col">Price</th>
                          {/* <th scope="col">Price(old)</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">1</th>
                          <td>Daily</td>
                          <td>{prices[0].premium}</td>
                          {/* <td>1,400</td> */}
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>Weekly</td>
                          <td>{prices[1].premium}</td>
                          {/* <td>6,500</td> */}
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>Monthly</td>
                          <td>{prices[2].premium}</td>
                          {/* <td>25,000</td> */}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {/* Dedicated Workspace Contact Modal */}
      {isDedicatedModalOpen && (
        <>
          <div
            className="modal fade show"
            role="dialog"
            aria-modal="true"
            aria-labelledby="dedicatedModalTitle"
            style={{ display: "block" }}
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                closeDedicatedModal();
              }
            }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content" style={{ border: "none", borderRadius: "15px", overflow: "hidden" }}>
                <div className="modal-header" style={{ backgroundColor: "#8a038c", color: "white", borderBottom: "none" }}>
                  <h5 className="modal-title" id="dedicatedModalTitle" style={{ color: "white" }}>
                    Contact Us About Dedicated Workspace
                  </h5>
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={closeDedicatedModal}
                    style={{ color: "white", opacity: 1 }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body" style={{ padding: "30px" }}>
                  <p className="mb-4" style={{ fontSize: "16px", color: "#666" }}>
                    Interested in a Dedicated Workspace? Please fill out the form below or email us at{" "}
                    <a href={`mailto:${contactEmail}`} style={{ color: "#8a038c", fontWeight: "bold" }}>{contactEmail}</a>
                  </p>
                  <form className="text-left">
                    <div className="form-group mb-3">
                      <label htmlFor="dedicatedName" style={{ fontWeight: "600", color: "#333" }}>Full Name</label>
                      <input
                        id="dedicatedName"
                        className="form-control"
                        name="name"
                        type="text"
                        placeholder="Enter your full name"
                        value={dedicatedContact.name}
                        onChange={handleDedicatedContactChange}
                        style={{ borderRadius: "8px", border: "1px solid #ddd", padding: "12px" }}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label htmlFor="dedicatedEmail" style={{ fontWeight: "600", color: "#333" }}>Email Address</label>
                      <input
                        id="dedicatedEmail"
                        className="form-control"
                        name="email"
                        type="email"
                        placeholder="Enter your email"
                        value={dedicatedContact.email}
                        onChange={handleDedicatedContactChange}
                        style={{ borderRadius: "8px", border: "1px solid #ddd", padding: "12px" }}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label htmlFor="dedicatedMessage" style={{ fontWeight: "600", color: "#333" }}>Message</label>
                      <textarea
                        id="dedicatedMessage"
                        className="form-control"
                        name="message"
                        rows="4"
                        placeholder="Tell us about your requirements"
                        value={dedicatedContact.message}
                        onChange={handleDedicatedContactChange}
                        style={{ borderRadius: "8px", border: "1px solid #ddd", padding: "12px" }}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <ReCAPTCHA
                        sitekey="6Lf7lGUsAAAAADF31fqBAAA-n2q3tMdpEcqkf6-W"
                        onChange={(token) => setRecaptchaToken(token)}
                      />
                    </div>
                  </form>
                </div>
                <div className="modal-footer" style={{ borderTop: "1px solid #eee", padding: "20px" }}>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeDedicatedModal}
                    style={{ borderRadius: "8px", padding: "10px 25px" }}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSubmitInquiry}
                    style={{
                      backgroundColor: "#8a038c",
                      borderColor: "#8a038c",
                      borderRadius: "8px",
                      padding: "10px 25px",
                      color: "white"
                    }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Sending..." : "Send Inquiry"}
                  </button>
                </div>
              </div>
            </div>
          </div >
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
};
export default Step1;